import { PORT_SERVER } from '../../../../Config';
import React, { useEffect, useState } from 'react'
import ImageGallery from 'react-image-gallery';
import { staticPathForBuildModeWithURL } from '../../../utils/ImageSlider';

function ProductImage(props) {
    const [Images, setImages] = useState([])

    useEffect(() => {
        if (props.detail.images && props.detail.images.length > 0) {
            let images = [];

            props.detail.images && props.detail.images.forEach(item => {
                const fullURL = staticPathForBuildModeWithURL(item)
                images.push({
                    original: fullURL,
                    thumbnail: fullURL
                })
            })
            setImages(images)
        }
    }, [props.detail])

    return (
        <div>
            <ImageGallery items={Images} />
        </div>
    )
}

export default ProductImage
